import { FC, ReactElement } from 'react'
import { Social } from './partials/social'
import { WrapLogin } from './partials/wrap'

export const ResendLinkSent: FC = (): ReactElement => (
  <WrapLogin>
    <form
      id="resetForm"
      name="resetForm"
      action="/"
      className="registration__form"
    >
      <h1 className="registration__title" style={{ visibility: 'hidden' }}>
        Reset your Password
      </h1>

      <div className="registration__right__body">
        <div className="registration__reset">
          <img
            src="/account/images/dest/registration/resetImg.svg"
            alt="resetImg"
            className="registration__rest__img"
          />
          <h2 className="registration__reset__title">
            Reset Password Link Sent!
          </h2>
          <p className="registration__reset__description">
            You We have emailed the instructions to reset your password, kindly
            check your mail
          </p>
          a
        </div>
      </div>

      <Social />
    </form>
  </WrapLogin>
)
